/* eslint-disable space-before-function-paren */
/* eslint-disable brace-style */
/* eslint-disable eqeqeq */
/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable spaced-comment */
/* eslint-disable indent */
// 这个版本是客户端风控参数获取处理和处理异常方式不同
import "./burySalog";
(function() {
  var pwd = window.pwd || {};

  //防重点
  let g_isStart = false;

  /*
    域名配置，不同环境不同域名
    */
  let config = (function() {
    let _config = {};
    //根据环境获取域名
    switch ($.base.getEnvName()) {
      case "PRE":
        _config.idsauthServerUrl = "https://passportpre.cnsuning.com";
        _config.idsauthUrl = "https://aqpre.cnsuning.com/asc/auth";
        _config.base = "https://mypre.cnsuning.com/";
        _config.actDomain = "//actpre.cnsuning.com";
        _config.vcsDomain = "//vcspre.cnsuning.com";
        break;
      case "XGPRE":
        // _config.idsauthServerUrl = "https://passportpre.cnsuning.com";
        // _config.idsauthUrl = "https://aqpre.cnsuning.com/asc/auth";
        // _config.base = "https://mypre.cnsuning.com/";
        // _config.actDomain = "//actpre.cnsuning.com";
        // _config.vcsDomain = "//vcspre.cnsuning.com";
        _config.idsauthServerUrl = "https://passportprexg.cnsuning.com";
        _config.idsauthUrl = "https://aqprexg.cnsuning.com/asc/auth";
        _config.base = "https://myprexg.cnsuning.com/";
        _config.actDomain = "//actprexg.cnsuning.com";
        _config.vcsDomain = "//vcspre.cnsuning.com";
        break;
      case "SIT":
        _config.idsauthServerUrl = "https://passportsit.cnsuning.com";
        _config.idsauthUrl = "https://aqsit.cnsuning.com/asc/auth";
        _config.base = "https://mysit.cnsuning.com/";
        _config.actDomain = "//actsit.cnsuning.com";
        _config.vcsDomain = "//vcspre.cnsuning.com";
        break;
      case "PRD":
        _config.idsauthServerUrl = "https://passport.suning.com";
        _config.idsauthUrl = "https://aq.suning.com/asc/auth";
        _config.base = "https://loginst.suning.com/";
        _config.dtDomain = "//dt.suning.com";
        _config.actDomain = "//act.suning.com";
        _config.vcsDomain = "//vcs.suning.com";
        break;
      default:
        _config.idsauthServerUrl = "https://passportprexg.cnsuning.com";
        _config.idsauthUrl = "https://aqprexg.cnsuning.com/asc/auth";
        _config.base = "https://myprexg.cnsuning.com/";
        _config.actDomain = "//actprexg.cnsuning.com";
        _config.vcsDomain = "//vcspre.cnsuning.com";
        break;
    }
    return _config;
  })();

  /*
    请求接口地址
    */
  let request_url = {
    //图片验证码接口
    imgCode: config.actDomain + "/act-wap-web/switch/get3.do",
    //获取手机号
    getPhoneNum:
      config.actDomain + "/act-wap-web/gateway/smscode/getUserSmsState.do",
    //发送短信接口
    getPhoneCode: config.actDomain + "/act-wap-web/gateway/sendSmsCode.do",
    //获取微信参数接口
    wxAutoLogin: config.actDomain + "/act-wap-web/gateway/weChart/autoLogin.do",
    //获取ticket
    getTicket: config.actDomain + "/act-wap-web/gateway/jigsaw/getTicket.do"
  };

  /*
    ajax请求
    @param url:接口地址
    @param head:请求头
    @param data:请求参数
    @param successCb:成功回调
    @param errorCb:失败回调
    */
  function ajaxJson(url, head, data, successCb, errorCb, dataType) {
    $.ajax({
      type: "GET",
      url: url,
      data: data,
      dataType: dataType || "json",
      // timeout: 10000,
      timeout: 3000,
      headers: head,
      jsonpCallback: "callback",
      beforeSend: function beforeSend(xhr) {
        try {
          xhr.withCredentials = true;
        } catch (e) {
          var nativeOpen = xhr.open;
          xhr.open = function() {
            var result = nativeOpen.apply(xhr, arguments);
            xhr.withCredentials = true;
            return result;
          };
        }
      },
      success: successCb,
      error:
        errorCb ||
        function() {
          AlertBox({
            type: "mini",
            delay: 2000,
            msg: "小苏正忙，请稍后再试"
          });
        }
    }).done(function(res) {
      //异常埋点
      console.log("passport");
      //接口名，入参，异常（直接用res）
      if (res && window.sendErrorMsg) {
        sendErrorMsg(res.api, data, res);
      } else {
        console.log("异常");
      }
    });
  }
  /**客户端判断 */
  pwd.os = (function() {
    //pp视频发生过一开始ua取不到的情况
    if (navigator && navigator.userAgent) {
      var e = navigator.userAgent;
      return {
        yifubao: !!e.match(/SNYifubao;?/i),
        wechat: !!e.match(/MicroMessenger/i),
        isApp:
          e.match(/SNEBUY-APP;?/i) &&
          !e.match(/NEARBY-APP;?/i) &&
          !e.match(/SNUNION-APP;?/i) &&
          !e.match(/SNLPG-APP;?/i),
        isBadAndroid:
          /Android /.test(window.navigator.appVersion) &&
          !/Chrome\/\d/.test(window.navigator.appVersion) &&
          !window.e.match(/SNLITE-WAP/i),
        android: e.match(/android/i),
        iOS: e.match(/(iPhone|iPod|iPad);?/i),
        iPad: e.match(/(iPad).*OS\s([\d_]+)/),
        iPod: e.match(/(iPod)(.*OS\s([\d_]+))?/),
        chrome: e.match(/Chrome\/([\d.]+)/),
        isNearby: e.match(/NEARBY-APP;?/i), //小店
        isSnUnion: e.match(/SNUNION-APP;?/i), //推客
        isPPTV: e.indexOf(" PPTV (") > 0,
        isPPTVSports: e.toLocaleLowerCase().match(/pptvsports/i),
        isLPG: e.match(/SNLPG-APP;?/i),
        ismobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(
          navigator.userAgent
        ),
        isPlaza: e.match(/SNYX-APP;?/i)
      };
    } else {
      return {};
    }
  })();
  /*
    风控初始化方法
    */
  pwd.init = function(params) {
    if (params) {
      if (!g_isStart) {
        g_isStart = true;
        pwd.passport(params);
      }
      setTimeout(function() {
        g_isStart = false;
      }, 500);
    }
  };

  /*
    判断是否登录
    */
  pwd.passport = function(opts) {
    $.probeAuthStatus(
      function() {
        if (opts.url && opts.url != "") {
          pwd.getCoupons(opts);
        } else {
          opts.cb ? opts.cb.call(null) : null;
        }
      },
      function() {
        var url = location.href;
        location.href =
          config.idsauthServerUrl +
          "/ids/login?service=" +
          encodeURIComponent(
            config.idsauthUrl + "?targetUrl=" + encodeURIComponent(url)
          ) +
          "&loginTheme=wap_new";
      }
    );
  };

  /*
    调用需要验证风控的接口
    */
  /**2019.6.6 16:53
     * 本次修改：
        app,vue里先行调用客户端获取设备指纹的方法，如果获取到了缓存
        兑换无敌券获取风控参数时，设备指纹优先调用客户端api，不存在api取cookie
        存在API，API回调走进去，如果参数存在，取改值，不存在，取cookie，cookie不存在，再取app,vue设置的sessionStorage里的值（该方法不灵，有时候走进去回调，有时候走不进，走进去也要判断值是否为空）
        存在API0.5秒后判断值是否为空，（走不进回调的时候）空则取cookie，cookie还取不到再取app.vue设置的sessionStorage里的值

        关于调用接口
        原逻辑取不到参数不调用，友好提示，上报异常，带上参数详情
        修改后：
        如果都获取到，调接口
        获取参数时捕获异常，调接口
        1.4秒后未获取到参数。调接口

        调用接口判断如果是客户端风控类型且风控参数有一个为空，上报异常
        上报异常详情增加userAgent和cookie信息
        异常埋点smcp-pkExpandRed-2403

        风控校验参数为空出挑战
     */
  pwd.getCoupons = function(opts) {
    opts.dataParams.appVersion = "";
    opts.dataParams.detect = "";
    opts.dataParams.deviceId = "";
    opts.dataParams._device_session_id = "";
    if (opts.riskType === "client") {
      var appVersion = "";
      var deviceId = "";
      var _device_session_id = "";
      var detect = "";
      var appReadyTimeout; //轮询检测客户端方法是否存在的定时器
      var hasGotAppParam = false; //是否已获取客户端参数，1.4秒后未获取也调用陪你过接口，上报异常
      var os = pwd.os;
      //易购客户端
      if (os.isApp) {
        try {
          var bridge = $.os.ios ? SNNativeClient : baseApi;
          function getClientRiskParams() {
            if (bridge && bridge.getClientInfo && bridge.humanMachineData) {
              //获取客户端信息。app版本号，设备唯一码
              var getClientInfo = new Promise((resolve, reject) => {
                bridge.getClientInfo(function(result) {
                  if (typeof result === "string") {
                    result = JSON.parse(result);
                  }
                  opts.dataParams.appVersion = appVersion = result.version;
                  opts.dataParams.deviceId = deviceId =
                    result.identifier || result.imei;
                  if (appVersion) resolve();
                });
              });
              // 获取客户端设备指纹
              var getDeviceIdentifier = new Promise((resolve, reject) => {
                //    老版本不存在getNewDeviceIdentifier方法，取cookie
                if (bridge.getNewDeviceIdentifier) {
                  /*客户端方法走不进回调，0.5秒后再取cookie，cookie为空，在取sessionStorage里（app.vue通过getNewDeviceIdentifier获取
                                    客户端这个方法有问题，有时候走不进回调，所以页面一开始就调用并缓存，调用接口再获取最新的，回调走不进去就取cookie，cookie没有尝试看
                                    一开始调用时候*/
                  var getTimeout = setTimeout(() => {
                    if (!_device_session_id) {
                      opts.dataParams._device_session_id = _device_session_id = $.cookie(
                        "dfpToken"
                      );
                      if (_device_session_id) {
                        resolve();
                      } else {
                        opts.dataParams._device_session_id = _device_session_id = sessionStorage.getItem(
                          "app_device_session_id"
                        );
                        resolve();
                      }
                    }
                  }, 500);
                  bridge.getNewDeviceIdentifier(function(result) {
                    clearTimeout(getTimeout);
                    if (result) {
                      opts.dataParams._device_session_id = _device_session_id = result;
                      resolve();
                    } else {
                      opts.dataParams._device_session_id = _device_session_id = $.cookie(
                        "dfpToken"
                      );
                      if (_device_session_id) {
                        resolve();
                      } else {
                        opts.dataParams._device_session_id = _device_session_id = sessionStorage.getItem(
                          "app_device_session_id"
                        );
                        resolve();
                      }
                    }
                  });
                } else {
                  opts.dataParams._device_session_id = _device_session_id = $.cookie(
                    "dfpToken"
                  );
                  resolve();
                }
              });
              var getHumanMachineData = new Promise((resolve, reject) => {
                bridge.humanMachineData(2, function(result) {
                  opts.dataParams.detect = detect = result.result || result;
                  if (detect) resolve();
                });
              });
              Promise.all([
                getClientInfo,
                getDeviceIdentifier,
                getHumanMachineData
              ]).then(() => {
                if (appVersion && detect && _device_session_id && deviceId) {
                  hasGotAppParam = true;
                  pastportAction();
                }
              });
            } else {
              appReadyTimeout = setTimeout(getClientRiskParams, 100);
            }
          }
          getClientRiskParams();
          setTimeout(() => {
            if (!hasGotAppParam) {
              clearTimeout(appReadyTimeout);
              console.log(appVersion, _device_session_id, detect);
              pastportAction(); //未获取参数仍然调用接口
              // AlertBox({
              //     type: "mini",
              //     delay: 3000,
              //     msg: opts.noRiskToast || '活动异常火爆，请稍后再试！！！'
              // });
              // 走到catch里面可能会不上报，所以上报异常放到接口调用里
              // if (opts.error_code) {
              //     sa.openAPI.sendMsgV2({
              //         bid: 'smcp',
              //         error_detail: 'appVersion:' + appVersion + '|deviceId:' + deviceId + '|_device_session_id:' + _device_session_id + '|detect:' + detect + '|userAgent:' + window.navigator.userAgent + '|cookie:' + JSON.stringify($.cookie()),
              //         error_type: '2',
              //         error_code: opts.error_code,
              //         type_name: '获取客户端人机参数、设备指纹等失败',
              //         member_id: $.cookie('custno'),
              //         member_level: $.cookie('custLevel'),
              //         region: $.cookie('SN_CITY'),
              //         status: 0
              //     });
              // }
            }
          }, 1400);
        } catch (error) {
          console.log(error);
          hasGotAppParam = true;
          pastportAction();
        }
      }
      // 金融客户端
      if (os.yifubao) {
        toast("暂不支持金融客户端兑换，请在苏宁易购客户端下兑换");
      }
      // 小店
      if (os.isNearby) {
        toast("暂不支持小店客户端兑换，请在苏宁易购客户端下兑换");
      }
      // pp视频
      if (os.isPPTV) {
        toast("暂不支持PP视频客户端兑换，请在苏宁易购客户端下兑换");
      }
      // pp体育
      if (os.isPPTVSports) {
        toast("暂不支持PP体育客户端兑换，请在苏宁易购客户端下兑换");
      }
      // 苏宁广场
      if (os.isPPTVSports) {
        toast("暂不支持苏宁广场客户端兑换，请在苏宁易购客户端下兑换");
      }
    } else if (opts.riskType === "H5") {
      opts.dataParams.detect = bd.rst();
      // opts.dataParams.deviceId = bd.ptoken();
      opts.dataParams._device_session_id = _dfp.getToken();
      pastportAction();
    }
    function pastportAction() {
      if (opts.riskType === "client" && opts.error_code) {
        if (
          !opts.dataParams.appVersion ||
          !opts.dataParams.detect ||
          !opts.dataParams._device_session_id
        ) {
          sa.openAPI.sendMsgV2({
            bid: "smcp",
            error_detail:
              "APP版本号:" +
              opts.dataParams.appVersion +
              "设备唯一标识：" +
              opts.dataParams.deviceId +
              "设备指纹:" +
              opts.dataParams._device_session_id +
              "人机参数:" +
              opts.dataParams.detect +
              "userAgent信息:" +
              window.navigator.userAgent +
              "|cookie信息:" +
              JSON.stringify($.cookie()),
            error_type: "2",
            error_code: opts.error_code,
            type_name: "获取客户端人机参数、设备指纹等失败",
            member_id: $.cookie("custno"),
            member_level: $.cookie("custLevel"),
            region: $.cookie("SN_CITY"),
            status: 0
          });
        }
      }
      //传入当前页面地址
      opts.dataParams.referenceURL = location.href;
      ajaxJson(
        opts.url,
        opts.headerParams,
        opts.dataParams,
        function(res) {
          $(".greensport-loading").remove();
          console.log("passport风控结果：", res);
          //中挑战--短信验证码、拼图验证码
          if (res.code == "10" && res.data.code == "19") {
            if (
              res.data.challengeObject &&
              res.data.challengeObject.challengeTypes &&
              res.data.challengeObject.challengeTypes.length > 0
            ) {
              pwd.challengeToast(
                res.data.challengeObject.challengeTypes[0],
                opts
              );
            }
          }
          //必开短信验证码
          else if (res.code == "10" && res.data.code == "16") {
            PhoneVerify.init(opts);
          }
          //必开拼图验证码
          else if (res.code == "10" && res.data.code == "17") {
            console.log("出拼图");
            //出拼图验证码
            CaptchaVerify.init(opts);
          }
          //中风控
          else if (res.code == "10" && res.data.code == "13") {
            opts.cb ? opts.cb.call(null, res) : null;
          }
          //中流控
          else if (res.code == "15") {
            AlertBox({
              type: "mini",
              delay: 2000,
              msg: opts.flowControl || "活动过于火爆，请稍后再试"
            });
            opts.errorCb ? opts.errorCb.call(null, res) : null;
          }
          //其他情况
          else {
            opts.cb ? opts.cb.call(null, res) : null;
          }
          g_isStart = false;
        },
        function(rs) {
          g_isStart = false;
          opts.errorCb ? opts.errorCb.call(null, rs) : null;
        }
      );
    }
  };
  /*
    中挑战，短信验证码、拼图验证码
    */
  pwd.challengeToast = function(type, opts) {
    //短信验证码
    if (type == 3) {
      PhoneVerify.init(opts);
    } else if (type == 4) {
      //拼图验证码
      console.log("出拼图");
      CaptchaVerify.init(opts);
    }
  };

  /*
    短信验证码组件
    */
  let PhoneVerify = {
    phoneNum: "",
    status: 0,
    opts: null,
    init: function(opts) {
      PhoneVerify.opts = opts;
      ajaxJson(
        request_url.getPhoneNum,
        {},
        {
          activityCode: opts.activityCode,
          smsSence: opts.smsSence || 1,
          detect: bd.rst(),
          _device_session_id: _dfp.getToken()
        },
        function(res) {
          $(".greensport-loading").remove();
          if (res.code == 1) {
            PhoneVerify.phoneNum = res.data.tele;
            PhoneVerify.status = res.data.state;
            PhoneVerify.render();
          } else {
            if (PhoneVerify.opts.errorCb)
              PhoneVerify.opts.errorCb.call(null, res);
          }
        },
        function(rs) {
          if (PhoneVerify.opts.errorCb) PhoneVerify.opts.errorCb.call(null, rs);
        }
      );
    },

    render: function() {
      var html = [
        '<div class="dialog-toast">',
        '   <div class="dialog-wrap">',
        '       <div class="dialog-title">手机验证</div>',
        '       <div class="dialog-phoneVerify">',
        "           <p>" + PhoneVerify.phoneNum + "</p>",
        '           <div class="ldp-phoneBox">',
        '               <div class="ldp-phoneVerify">',
        '                   <input maxlength="6" type="tel" placeholder="输入验证码">',
        "               </div>",
        '               <a href="javascript:void(0)" class="verify-send">获取验证码</a>',
        "           </div>",
        '           <div class="phoneVerify-error"></div>',
        '           <a href="javascript:void(0)" class="btn phoneVerify-submit">确定</a>',
        "       </div>",
        '       <div class="dialog-close"></div>',
        "   </div>",
        "</div>"
      ].join("");
      $(".dialog-toast").remove();
      $("body")
        .append(html)
        .on("touchmove", function(e) {
          e.preventDefault();
        });
      PhoneVerify.bind();
    },

    bind: function() {
      $(".verify-send").tap(function() {
        var _this = $(this);
        if (_this.hasClass("hasSend")) return;
        _this.addClass("hasSend");

        ajaxJson(
          request_url.getPhoneCode,
          {},
          {
            activityCode: PhoneVerify.opts.activityCode,
            smsSence: PhoneVerify.opts.smsSence,
            detect: bd.rst(),
            _device_session_id: _dfp.getToken()
          },
          function(res) {
            if (res.code == "16" || res.code == "22") {
              if (PhoneVerify.opts.errorCb)
                PhoneVerify.opts.errorCb.call(null, res);
            } else if (res.data) {
              if (res.data.state == "1") {
                AlertBox({
                  type: "mini",
                  delay: 3000,
                  msg: "该账号超过每日最大发送次数"
                });
              } else if (res.data.errorCode == "1001") {
                PhoneVerify.phoneCodeCount(res.data.state);
              } else if (res.data.errorCode == "90002") {
                AlertBox({
                  type: "mini",
                  delay: 3000,
                  msg: "该账号超过每日最大发送次数"
                });
                _this.removeClass("hasSend");
              } else {
                AlertBox({
                  type: "mini",
                  delay: 3000,
                  msg: "发送失败，请稍后再试"
                });
                _this.removeClass("hasSend");
              }
            } else {
              AlertBox({
                type: "mini",
                delay: 3000,
                msg: "发送失败，请稍后再试"
              });
              _this.removeClass("hasSend");
            }
          },
          function(rs) {
            _this.removeClass("hasSend");
            if (PhoneVerify.opts.errorCb)
              PhoneVerify.opts.errorCb.call(null, rs);
          }
        );
      });

      //验证码确定
      $(".phoneVerify-submit").tap(function() {
        var $this = $(this);
        if ($this.hasClass("loading-btn")) return false;
        $this.addClass("loading-btn");
        PhoneVerify.validate();
      });

      $(".dialog-toast .dialog-close").tap(function() {
        $("body").off("touchmove");
        $(".dialog-toast").remove();
        if (PhoneVerify.opts.closeCb) PhoneVerify.opts.closeCb.call(null);
      });
    },

    phoneCodeCount: function(endStatus) {
      var _this = $(".verify-send");
      _this.addClass("hasSend");
      if (PhoneVerify.codeDownCount) clearInterval(PhoneVerify.codeDownCount);
      var downCount = 59;

      _this.text("再次获取" + downCount + "s");
      PhoneVerify.codeDownCount = setInterval(function() {
        if (downCount < 2) {
          if (endStatus == 0) {
            _this.text("重新获取").removeClass("hasSend");
          } else {
            _this.text("今日次数已用完");
          }
          clearInterval(PhoneVerify.codeDownCount);
        } else {
          _this.text("再次获取" + --downCount + "s");
        }
      }, 1000);
    },

    validate: function() {
      //验证码判空
      if ($.trim($(".ldp-phoneBox input").val()) == "") {
        $(".dialog-phoneVerify .phoneVerify-error").text("请输入验证码");
        $(".phoneVerify-submit").removeClass("loading-btn");
        return false;
      } else {
        $(".dialog-verify .phoneVerify-error").empty();
      }

      //验证码正确性校验
      PhoneVerify.opts.dataParams.smscode = $(".ldp-phoneBox input").val();
      ajaxJson(
        PhoneVerify.opts.url,
        PhoneVerify.opts.headerParams,
        PhoneVerify.opts.dataParams,
        function(res) {
          if (res.code == 10) {
            $(".dialog-phoneVerify .phoneVerify-error").text(
              "请输入正确验证码"
            );
            $(".phoneVerify-submit").removeClass("loading-btn");
          } else {
            if (PhoneVerify.opts.cb) PhoneVerify.opts.cb.call(null, res);
            $(".dialog-toast").remove();
            $("body").off("touchmove");
          }
        },
        function(rs) {
          $(".phoneVerify-submit").removeClass("loading-btn");
          if (PhoneVerify.opts.errorCb) PhoneVerify.opts.errorCb.call(null, rs);
        }
      );
    }
  };

  /*
    拼图验证码
    */
  let CaptchaVerify = {
    //参数
    opts: null,
    /*
        初始化，调用接口获取ticket
        */
    init(opts) {
      CaptchaVerify.opts = opts;
      let url = request_url.getTicket;
      let data = {
        activityCode: opts.activityCode
      };
      ajaxJson(url, {}, data, CaptchaVerify.successCb, CaptchaVerify.errorCb);
    },

    /*
        获取ticket成功后执行
        */
    successCb(res) {
      console.log("拼图ticket", res);
      $(".greensport-loading").remove();
      if (res && res.code == "1") {
        SnCaptcha.init({
          id: "captcha", //任意值均可
          env:
            $.base.getEnvName().toLocaleLowerCase() == "xgpre"
              ? "sit"
              : $.base.getEnvName().toLocaleLowerCase(), //环境sit,xgpre,prd
          type: "popup", //方式插入按钮式  inline：出现点击按钮；popup：不出点击按钮，直接出拼图。
          target: "captcha", //验证码按钮插入的div的id，必填
          ticket: res.data.result.ticket,
          height: "40px", //滑块或按钮高度(必填，且必须用具体数值，禁止使用百分比)
          width: "300px",
          callback: function(token) {
            //回调函数
            CaptchaVerify.verifyAgain(token);
          }
        });
      }
    },

    /*
        重新验证
        */
    verifyAgain(token) {
      //验证码正确性校验
      CaptchaVerify.opts.dataParams.riskToken = token;
      ajaxJson(
        CaptchaVerify.opts.url,
        CaptchaVerify.opts.headerParams,
        CaptchaVerify.opts.dataParams,
        function(res) {
          console.info("重新验证风控结果", res);
          if (CaptchaVerify.opts.cb) {
            CaptchaVerify.opts.cb.call(null, res);
          }
        },
        function(rs) {
          if (CaptchaVerify.opts.errorCb) {
            CaptchaVerify.opts.errorCb.call(null, rs);
          }
        }
      );
    },

    /*
        获取ticket失败后执行
        */
    errorCb() {
      $(".greensport-loading").remove();
      console.log("获取ticket失败");
    }
  };

  /*
    对外变量名称 passport
    */
  window.passport = pwd;
})();
